import React from "react";
import { Text } from "./text";

type FormattedCurrencyProps = {
	amount?: number | null | undefined; // Assuming the amount is a number
	sx?: any;
	component?: React.ElementType;
	zeroIsFree?: boolean;
};

export const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({ amount, sx, component: Component, zeroIsFree }) => {
	if (amount == null) {
		return null;
	}

	if (amount === 0 && zeroIsFree) {
		if (Component) {
			return <Component sx={sx}>Free</Component>;
		}

		return <Text sx={sx}>Free</Text>;
	}

	const formattedAmount = amount.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	if (Component) {
		return <Component sx={sx}>{formattedAmount}</Component>;
	}

	return <Text sx={sx}>{formattedAmount}</Text>;
};
